import styled from 'styled-components'

import Tag from '~/shared/components/tags/Tag'

type Props = {
  data: string
}

function Etc({ data }: Props) {
  return (
    <Wrapper>
      <Tag $size="md" $variant="gray">
        기타 사항
      </Tag>
      <Desc>{data}</Desc>
    </Wrapper>
  )
}

export default Etc

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  height: auto;
  padding: 36px 24px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`

const Desc = styled.p`
  font-size: 18px;
  line-height: 25px;
  white-space: pre-line;
`
